import { useMemo } from 'react';
import PropTypes from 'prop-types';

import Icon from 'common/Icon/Icon';
import Scroll from 'common/Scroll/Scroll';

import styles from './ExpandedModule.module.scss';

const iconNames = {
  'Social Monitoring': 'socialMonitoringModule',
  Insights: 'insightsModule',
  'SOSV Experts': 'sosvExpertsModule',
  'SOSV Science': 'sosvScienceModule',
  'Custom Content': 'customReportsModule',
  'Global KOL Planning': 'globalKOLPlanningModule',
  'Insights Capture': 'insightsCaptureModule',
  'Insights NEW': 'insightsNextGenModule',
};

const moduleNames = {
  'Social Monitoring': 'Social',
  'Global KOL Planning': 'Planning',
  'Insights Capture': 'Insights',
  'Insights NEW': 'Insights',
};

export const ExpandedModule = ({ index, module, active, expanded, content, onNavigate }) => {
  const hasNewBadge = useMemo(() => module.name.includes('NEW'), [module]);
  return (
    <section
      className={`
        ${styles.container} 
        ${expanded === index ? styles.active : styles['not-active']} 
        ${styles.expanded}
      `}
    >
      <div className={styles['icon-name']} onClick={onNavigate}>
        <Icon name={iconNames[module.name]} size={24} />

        <span className={active ? styles['text-active'] : styles['text-inactive']}>
          {moduleNames[module.name] || module.name}
        </span>
        {hasNewBadge && <div className={styles['menu-tag']}>NEW</div>}
      </div>

      {expanded === index && (
        <section className={styles.content}>
          <Scroll hideArrow>{content}</Scroll>
        </section>
      )}
    </section>
  );
};

ExpandedModule.propTypes = {
  active: PropTypes.bool.isRequired,
  content: PropTypes.node.isRequired,
  onNavigate: PropTypes.func.isRequired,
  expanded: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  module: PropTypes.shape({
    id: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string,
    navLink: PropTypes.string,
  }).isRequired,
};
